import { Inject, Injectable } from '@angular/core';
import {
  AuthHeaders,
  BaseApiService,
  CoreInjectorTokens,
  Environment,
  GetManyDto,
  ResponseDto,
} from '@fleet-beat/core';
import { catchError, map, Observable } from 'rxjs';
import { TrackingTrucksModel } from '@fleet-beat/libs-core/src/lib/models/tracking-trucks.model';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class TrackingTrucksApiService {
  private readonly baseUrl: string = `${this.environment.apiEndpoint}/external/tracking-info`;

  constructor(
    @Inject(CoreInjectorTokens.Environment) private environment: Environment,
    private baseApiService: BaseApiService,
  ) {}

  getTrackingTruck(params: GetManyDto, auth: AuthHeaders): Observable<TrackingTrucksModel> {
    return this.baseApiService.get(`${this.baseUrl}`, { auth, params }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<TrackingTrucksModel>) => this.baseApiService.mapResponse(response)),
    );
  }
}
